import * as z from "zod/v4";

export const OperatorSchema = z.enum(["CONTAINS"]);
export type Operator = z.infer<typeof OperatorSchema>;
